import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { IOnboardingGroup } from '@models/OnboardingGroup.model';
import {
  Container,
  Overlay,
  Close,
  Header,
  Title,
  Line,
  Confirm,
  Cancel,
  Description,
  AssetInfo,
  AssetInfoTop,
  ProductName,
  Internal,
  AssetInfoBottom,
  AssetInfoLabel,
  AssetInfoContent,
} from './ConfirmDialog.styles';

interface IConfirmDialog {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  title: string;
  description: string;
  showAsset?: boolean;
  group?: IOnboardingGroup;
  isLarge?: boolean;
  internalManufacturer?: boolean;
  hideCancel?: boolean;
}

export const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  description,
  title,
  showAsset,
  group,
  isLarge,
  internalManufacturer,
  hideCancel,
}: IConfirmDialog) => {
  const portalDiv = document.getElementById('portal');

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container isLarge={isLarge}>
            <Header>
              <Title>{title}</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>

            {showAsset && !!group && (
              <AssetInfo>
                <AssetInfoTop>
                  <ProductName>{group.productName}</ProductName>
                  <Internal>Internal</Internal>
                </AssetInfoTop>
                <AssetInfoBottom>
                  <AssetInfoLabel>
                    <div>Model #:</div>
                    <div>Manufacturer:</div>
                  </AssetInfoLabel>
                  <AssetInfoContent>
                    <div>{group.model}</div>
                    <div>
                      {group.manufacturer}{' '}
                      {internalManufacturer && <span>(Internal)</span>}
                    </div>
                  </AssetInfoContent>
                </AssetInfoBottom>
              </AssetInfo>
            )}

            <Description>{description}</Description>

            <Line>
              {!hideCancel && (
                <Cancel type="button" onClick={onClose}>
                  Undo
                </Cancel>
              )}
              <Confirm
                type="button"
                disabled={isLoading}
                onClick={() => {
                  onConfirm();
                }}
              >
                OK
              </Confirm>
            </Line>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
